import { useState } from 'react';
import type { FC, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '../hooks/use-auth';
import { Login } from '../containers/login';
import { Scope } from '../lib/rbac';

interface AuthGuardProps {
  children: ReactNode;
  /** When set, the user's role must grant this scope or they are redirected. */
  requiredScope?: Scope;
}

export const AuthGuard: FC<AuthGuardProps> = (props) => {
  const { children, requiredScope } = props;
  const auth = useAuth();
  // const { isLogged } = useSelector((state: RootState) => state.auth);
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  // console.log(auth, location, requestedLocation);

  if (!auth.isAuthenticated) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }

    // return (
    //   <Login />
    // );
  }

  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  // Role-based gate: authenticated but lacking the required scope -> send home.
  if (auth.isAuthenticated && requiredScope && !auth.can(requiredScope)) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
  requiredScope: PropTypes.string as any
};
